// components/IncidentAnalysis.tsx
import React from 'react';
import { IncidentAnalysis } from '../types/incident';
import SummaryCard from './incident-analysis/SummaryCard';
import AssignmentTimeline from './incident-analysis/AssignmentTimeline';
import RiskAssessment from './incident-analysis/RiskAssessment';
import CauseAndSolution from './incident-analysis/CauseAndSolution';
import ActionItems from './incident-analysis/ActionItems';
import HistoricalContext from './incident-analysis/HistoricalContext';

interface IncidentAnalysisProps {
    analysis: IncidentAnalysis;
    incidentId: string;
}

const IncidentAnalysisComponent: React.FC<IncidentAnalysisProps> = ({ analysis, incidentId }) => {

    return (
        <div className="space-y-6">
            <SummaryCard analysis={analysis} />
            <AssignmentTimeline analysis={analysis} />
            <RiskAssessment analysis={analysis} />
            <CauseAndSolution analysis={analysis} />
            <ActionItems analysis={analysis} />
            <HistoricalContext analysis={analysis} />
        </div>
    );
};

export default IncidentAnalysisComponent;
